module.exports = __webpack_public_path__ + "static/media/0030.062c2a44.svg";